import { IEntity } from '@pf/shared-common';
import {
    CustomerFragment,
    ItemDimension,
    ItemFragment,
    PackingListSearchRequestParams,
    PackingListViewModelCreateBody,
    PackingListViewModelRead,
    PackingStatus,
    ResourceAuth,
    WarehouseFragment,
    Weight,
} from '@control-tower/platform-wms';
import { CustomFieldDto } from '@pf/shared/util-platform';
import { IWarehouseEntity } from '../interfaces/warehouse-entity';
import { PackLineDto } from './pack-line.dto';

export type PackingListRead = PackingListViewModelRead & IEntity;
export type PackingListCreate = PackingListViewModelCreateBody;
export type PackingListSearchParams = PackingListSearchRequestParams;

export class PackingListDto implements IWarehouseEntity {
    constructor(data: Partial<PackingListDto>) {
        Object.assign(this, data);
    }
    id!: string;
    warehouse!: WarehouseFragment;
    packingListNumber!: string;
    packingListDate?: string;
    status?: PackingStatus;
    resourceAuth?: ResourceAuth;
    projectId?: string | null;
    pickListId?: string | null;
    shipmentId?: string | null;
    createdDate?: string;
    modifiedDate?: string;
    isDeleted?: boolean;
    // item represents the box that is being packed
    item?: ItemFragment;
    customer?: CustomerFragment;
    // pack lines represent the items that are being packed into the box
    packLines: PackLineDto[] = [];
    assignedTo?: string;
    weight?: Weight;
    dimensions?: ItemDimension;
    customFields?: Array<CustomFieldDto> | null;
}
